var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ZyroPopup',{attrs:{"offset":{
		top:38,
		left:'unset'
	},"type":"no-padding","show-close-button":false}},[_c('template',{slot:"trigger"},[_c('EditTextButton',[_c('ZyroSvg',{attrs:{"name":_vm.iconName}})],1)],1),_c('ZyroIconControls',{staticClass:"text-align__controls",attrs:{"current":_vm.align,"icons":_vm.$options.valuesAlign,"theme":"rounded","toggleable":false},on:{"update:current":function($event){_vm.align=$event}}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }